import { Toast, ToastProvider as HeroUIToastProvider, toastQueue } from '@heroui/react';

export function AppToastProvider() {
  return (
    <HeroUIToastProvider queue={toastQueue} placement="bottom end" maxVisibleToasts={3}>
      {(toast) => (
        <Toast {...toast} className="bg-[var(--color-bg-card)] border border-[var(--color-border-default)] text-[var(--color-text-primary)] rounded-lg shadow-xl">
          <Toast.Content>
            <Toast.Title className="font-medium text-sm" />
            <Toast.Description className="text-xs text-[var(--color-text-secondary)]" />
          </Toast.Content>
          <Toast.CloseButton />
        </Toast>
      )}
    </HeroUIToastProvider>
  );
}

export { toastQueue };
